function setCssViewportHeight() {
    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function connect(initializeCallback = () => {}) {
    setCssViewportHeight();
    initializeCallback();
}